export const SDRN_TRUST_BASE = 'sdrn:coches.net:user:pro-'

export const VEHICLE_RATING_CATEGORY = {
  CONSUMPTION: 'consumption',
  OVERALL: 'overall',
  QUALITY_PRICE_RATIO: 'qualityPriceRatio',
  SAFETY: 'safety'
}
